import { gql } from "@apollo/client";

export const GET_PROFILE = gql`
  query GetProfile {
    getProfile {
      id
      email
      roles
      username
      bio
      location
      skills
      title
      profilePhoto
      coverPhoto
      x
      linkedin
      github
      website
      mobile
      experiences {
        title
        company
        duration
        description
        accomplishments
      }
      certifications {
        name
        url
      }
      education {
        institution
        degree
        fieldOfStudy
        startDate
        endDate
        description
      }
    }
  }
`;

export const GET_PROFILE_PIC = gql`
  query GetProfilePic($filename: String!) {
    getProfilePicByName(filename: $filename) {
      base64Data
      mimetype
    }
  }
`;

export const GET_USER_BY_ID = gql`
  query GetUserById($id: Int!) {
    getUserById(id: $id) {
      id
      username
      email
      roles
      title
      location
      skills
      bio
      profilePhoto
      coverPhoto
      linkedin
      github
      website
      x
    }
  }
`;

export const FILTERED_USERS_QUERY = gql`
  query FilteredUsers(
    $search: String,
    $roles: [String!],
    $location: String,
    $page: Int,
    $limit: Int
  ) {
    filteredUsers(
      search: $search,
      roles: $roles,
      location: $location,
      page: $page,
      limit: $limit
    ) {
      users {
        id
        username
        email
        roles
        profilePhoto
        bio
        skills
        location
      }
      meta {
        totalItems
        itemCount
        itemsPerPage
        totalPages
        currentPage
      }
    }
  }
`;
export const FILTERED_TRAININGS_QUERY = gql`
query FilteredTrainings(
  $search: String,
  $category: String,
  $level: String,
  $format: String,
  $certificate: Boolean,
  $location: String,
  $minPrice: Float,
  $maxPrice: Float,
  $page: Int,
  $limit: Int
) {
  filteredTrainings(
    search: $search,
    category: $category,
    level: $level,
    format: $format,
    certificate: $certificate,
    location: $location,
    minPrice: $minPrice,
    maxPrice: $maxPrice,
    page: $page,
    limit: $limit
  ) {
    trainings {
      id
      title
      description
      provider
      price
      duration
      level
      format
      category
      certificate
      location
      image
      enrollments
    }
    meta {
      totalItems
      itemCount
      itemsPerPage
      totalPages
      currentPage
    }
  }
}
`;
export const GET_TRAINING_IMAGE = gql`
query GetTrainingImage($filename: String!) {
  getTrainingImageByName(filename: $filename) {
    base64Data
    mimetype
  }
}
`;

export const GET_TRAINING_BY_ID = gql`
  query GetTrainingById($id: Int!) {
    getTrainingById(id: $id) {
      id
      title
      provider
      price
      rating
      enrollments
       providerEntity {
      id
      name
      logoUrl
     }
      reviews
      duration
      level
      format
      category
      startDate
      description
      image
      enrolledUserIds
      instructor {
        name
        email
        specialization
      }
      requirements
      language
      certificate
      modules {
        title
        description
      }
      labs {
        title
        description
      }
      resources {
        name
        description
      }
      location
    }
  }
`;

// Admin query to get training by ID with additional admin-specific fields
export const GET_TRAINING_BY_ID_ADMIN = gql`
  query GetTrainingByIdAdmin($id: Int!) {
    getTrainingById(id: $id) {
      id
      title
      description
      provider
      price
      duration
      level
      format
      category
      startDate
      language
      certificate
      location
      image
      rating
      reviews
      enrollments
      enrolledUserIds
      instructor {
        name
        email
        specialization
      }
      requirements
      modules {
        title
        description
      }
      labs {
        title
        description
      }
      resources {
        name
        description
      }

    }
  }
`;

export const GET_TRAINING_ENROLLMENTS = gql`
  query GetTrainingEnrollments(
    $trainingId: Int!
    $status: String
    $search: String
    $page: Int
    $limit: Int
  ) {
    trainingEnrollments(
      trainingId: $trainingId
      status: $status
      search: $search
      page: $page
      limit: $limit
    ) {
      enrollments {
        id
        status
        enrolledAt
        user {
          id
          username
          email
          profilePhoto
          mobile
        }
      }
      meta {
        totalItems
        itemCount
        itemsPerPage
        totalPages
        currentPage
      }
    }
  }
`;



export const GET_ADMIN_STATS = gql`
  query GetAdminStats {
    adminStats {
      users {
        total
        newUsersToday
        newUsersThisWeek
        newUsersThisMonth
        roleDistribution {
          role
          count
        }
      }
      providers {
        total
        newProvidersToday
        newProvidersThisWeek
        newProvidersThisMonth
      }
      trainings {
        total
        newTrainingsToday
        newTrainingsThisWeek
        newTrainingsThisMonth
        averagePrice
      }
      enrollments {
        total
        newEnrollmentsToday
        newEnrollmentsThisWeek
        newEnrollmentsThisMonth
        totalRevenue
      }
      trainingCategories {
        category
        count
      }
    }
  }
`;

export const GET_ADMIN_STATS_WITH_TIME_PERIOD = gql`
  query GetAdminStatsWithTimePeriod($timePeriod: TimePeriodInput) {
    adminStats(timePeriod: $timePeriod) {
      users {
        total
        newUsersToday
        newUsersThisWeek
        newUsersThisMonth
        roleDistribution {
          role
          count
        }
      }
      providers {
        total
        newProvidersToday
        newProvidersThisWeek
        newProvidersThisMonth
      }
      trainings {
        total
        newTrainingsToday
        newTrainingsThisWeek
        newTrainingsThisMonth
        averagePrice
      }
      enrollments {
        total
        newEnrollmentsToday
        newEnrollmentsThisWeek
        newEnrollmentsThisMonth
        totalRevenue
      }
      trainingCategories {
        category
        count
      }
    }
  }
`;

export const MY_TRAININGS_QUERY = gql`
  query MyTrainings(
    $search: String
    $category: String
    $level: String
    $format: String
    $certificate: Boolean
    $location: String
    $minPrice: Float
    $maxPrice: Float
    $page: Int
    $limit: Int
  ) {
    myTrainings(
      search: $search
      category: $category
      level: $level
      format: $format
      certificate: $certificate
      location: $location
      minPrice: $minPrice
      maxPrice: $maxPrice
      page: $page
      limit: $limit
    ) {
      trainings {
        id
        title
        description
        price
        category
        level
        format
        certificate
        createdBy
        image
      }
      meta {
        totalItems
        itemCount
        itemsPerPage
        totalPages
        currentPage
      }
    }
  }
`;


export const DELETE_TRAINING = gql`
mutation DeleteTraining($id: Int!) {
  deleteTraining(id: $id)
}
`;